import React from 'react';
import { Typography } from '@hpstellar/core/visId';

import withPageComponents from '../../../page/components/with-page-components';
import { Helpers } from '../../../core/src/helpers';

import './payment-methods.less';

export default withPageComponents(
    ({ title = 'Accepted payment methods', cartSettings }) => {
        const { paymentMethods } = cartSettings || {};
        return (
            <div className="pmt-methods">
                <Typography variant="h4" tag="h4" className="title-text">
                    {title}
                </Typography>
                <div className="pmt-method-list">
                    {(paymentMethods || []).map(method => {
                        const { key, svg, imgSrc, altText } = method;
                        return (
                            <div key={key} className="pmt-method">
                                {svg ? (
                                    <span
                                        className="svg-ctn"
                                        alt={altText}
                                        dangerouslySetInnerHTML={Helpers.createMarkup(svg)}
                                    />
                                ) : (
                                    <img src={imgSrc} alt={altText} />
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    },
    { components: ['cartSettings'] },
);
